/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';

export default function Description({ groups }) {
  return (
    <>
      {groups.map((group, index) => (
        <div key={index} className="mb-1">
          {group.name}
          {group.items && (
          <ul>
            {group.items.map((item, itemIndex) => (
              <li className="mt-1 mb-1" key={itemIndex}>{item.name}</li>
            ))}
          </ul>
          )}
        </div>

      ))}
    </>
  );
}

Description.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object),
};

Description.defaultProps = {
  groups: [],
};
